import { render } from "./empty-page.vue?vue&type=template&id=a71d1d12&scoped=true"
import script from "./empty-page.vue?vue&type=script&lang=js"
export * from "./empty-page.vue?vue&type=script&lang=js"

import "./empty-page.vue?vue&type=style&index=0&id=a71d1d12&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/security/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a71d1d12"]])

export default __exports__